// AI Assistant chat → backend /assistant router.
import { api } from "./client";

// Public (landing page) — KB-only help, no auth.
export const chatPublic = (message, history = []) =>
  api.post("/assistant/chat/public", { message, history });

// Signed-in — help + answers about the user's own data.
// bot_mode: "help" (KB only) | "data" (user data only) | "" (both)
export const chatApp = (message, history = [], bot_mode = "") =>
  api.post("/assistant/chat", { message, history, bot_mode });
